import axios from 'axios';
import { API_URI } from '../../constants/GlobalConstants';

// Create a new cost template
export const createCostTemplate = ({ title,productTypes, components, token }) => async (dispatch) => {
    try {
        dispatch({ type: 'COST_TEMPLATE_CREATE_REQUEST' });
        const { data } = await axios.post(
            `${API_URI}/api/templates`,
            { title, components,productTypes },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        dispatch({ type: 'COST_TEMPLATE_CREATE_SUCCESS', payload: data.template });
    } catch (error) {
        dispatch({
            type: 'COST_TEMPLATE_CREATE_FAIL',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Fetch all cost templates
export const fetchAllCostTemplates = ({ token }) => async (dispatch) => {
    try {
        dispatch({ type: 'COST_TEMPLATE_FETCH_ALL_REQUEST' });
        const { data } = await axios.get(
            `${API_URI}/api/templates`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({ type: 'COST_TEMPLATE_FETCH_ALL_SUCCESS', payload: data });
    } catch (error) {
        dispatch({
            type: 'COST_TEMPLATE_FETCH_ALL_FAIL',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Update a cost template
export const updateCostTemplate = ({ id, title,productTypes, components, token }) => async (dispatch) => {
    try {
        dispatch({ type: 'COST_TEMPLATE_UPDATE_REQUEST' });
        const { data } = await axios.put(
            `${API_URI}/api/templates/${id}`,
            { title, components,productTypes },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        dispatch({ type: 'COST_TEMPLATE_UPDATE_SUCCESS', payload: data.template });
    } catch (error) {
        dispatch({
            type: 'COST_TEMPLATE_UPDATE_FAIL',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Delete a cost template
export const deleteCostTemplate = ({ id, token }) => async (dispatch) => {
    try {
        dispatch({ type: 'COST_TEMPLATE_DELETE_REQUEST' });
        await axios.delete(
            `${API_URI}/api/templates/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({ type: 'COST_TEMPLATE_DELETE_SUCCESS', payload: id });
    } catch (error) {
        dispatch({
            type: 'COST_TEMPLATE_DELETE_FAIL',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};